import { SideBarOptionMenu } from '@/types/sidebar'
import { BsFillPersonLinesFill } from 'react-icons/bs'

export const userDashboardMenu: SideBarOptionMenu = {
  name: 'Dashboard',
  icon: BsFillPersonLinesFill,
  path: '/dashboard',
  order: 1,
  // permission: { name: 'settings', can: 'visible' },
  permission: null,
  isShown: true,
  isActive: false,
  child: [],
}
